import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const QuoteLineItemListDetails = () => {
  const columns = [
    { label: 'Quote', value: 'quote' },
    { label: 'Quantity', value: 'quantity' },
    { label: 'Unit Price', value: 'unit_price' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/quote/line-item/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['quoteLineItem']} />;
};

export default QuoteLineItemListDetails;